export async function initNewRelic() {
  const newrelicStatus = process.env.NEWRELIC_SWITCH

  let module
  if (newrelicStatus === 'true') {
    console.info(`New Relic initialization for Current Environment`)
    module = await import('./newrelic.js')
  } else {
    console.warn(`NEWRELIC is not set or invalid. Skipping New Relic initialization.`)
    return
  }

  module.initNewRelic()
}
